import { composeSDKFactories } from './composeSdks';
import type { CreateBaseSdkFactory } from './baseSdk';
import { createBaseSdk } from './baseSdk';
import { createVisibilitySdk } from './visibilitySdk';

export const elementSdkFactory: CreateBaseSdkFactory = type =>
  composeSDKFactories([createBaseSdk(type), createVisibilitySdk]);
